module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/andrey_1d31f1.png";